
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import { applyStyle } from 'ol-mapbox-style';
import { Style, Fill, Stroke, Text } from 'ol/style';
import { FeatureLike } from "ol/Feature";
import { mapState } from '../map';
import { getDigitaleKatastralmappeSource, getGstFid } from './digitaleKatastralmappe';




const selectedStyle = new Style({
    stroke: new Stroke({
        color: 'rgba(200,0.0,0.8)',
        width: 2,
    }),
    fill: new Fill({
        color: 'rgba(200,0,0,0.4)',
    }),
});




// The search layer visualizes the search results.
export const selectionLayer = new VectorTileLayer({
     source: getDigitaleKatastralmappeSource(),
    declutter: true,
    style: (feature, resolution) => {
        const fid = getGstFid(feature);
        if (fid && mapState.selectedFeatures.get(fid)) {
            return selectedStyle;
        } else { return []; }
    },
    visible:true 
});



